module.exports = __webpack_public_path__ + "static/media/Icone_2.007be542.png";